<template>
    <div>
        <a v-if="isActiveSec()"
           :href="navi.anchor"
           :class="{active: isLinkActive()}"
           v-html="navi.value">
        </a>
        <router-link v-else :to="{path: navi.chapter}" v-html="navi.value"></router-link>
        <section v-if="isActiveSec() && navi.submenu.length">
            <sdk-docs-navi-section v-for="(sub, index) in navi.submenu" :navi="sub" :key="index" />
        </section>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SdkDocsNaviSection',
  props: {
    navi: {
      type: Object,
      default: () => { return { elem: null, value: null, submenu: [] } }
    }
  },
  computed: {
    ...mapState({
      section: state => state.sdk.section
    })
  },
  methods: {
    isLinkActive () {
      return !!this.section && (this.section === this.navi.section || this.section.startsWith(this.navi.section + '.'))
    },
    isActiveSec () {
      return this.section && (this.section === this.navi.index || this.section.startsWith(this.navi.index + '.'))
    }
  }
}
</script>
